import { useNavigate, useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import ProductFormContent from './ProductFormContent';

function ProductForm() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <Box>
      <ProductFormContent
        productId={id}
        onCancel={() => navigate('/products')}
        onSuccess={() => navigate('/products')}
      />
    </Box>
  );
}

export default ProductForm;
